"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
var _actionUtils = require("../../utils/actionUtils");
function toggleNotificationList(status) {
  return (0, _actionUtils.actionCreator)(_types.TOGGLE_NOTIFICATION_LIST, status);
}
var _default = exports["default"] = toggleNotificationList;